import { Collapse, Divider, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import styled from "styled-components";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { theme } from "../../../../helpers/theme";
import FormFieldInfo from "../../../common-views/offer-form/components/form-field-info/form-field-info";
import LockIcon from '@mui/icons-material/Lock';
import { PasswordChange } from "../components/password-change/password-change";
import { ReactNode } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface SectionSettingsProps {
    visibleSectionValue: number;
    isVisibleSectionValue: boolean;
    popoverContent?: string;
    popoverLabel?: string;
    necessaryFildInfo?: boolean;
    sectionTitle: string;
    collapseComponent: ReactNode;
    sectionIcon: ReactNode;
    disabled: boolean;
    //message: string;
    //openSuccessInfo: boolean;
    //setOpenSuccessInfo: (openSuccessInfo: boolean) => void;
    handleToggleClick: (visibleSectionValue: number) => void;
    setIsVisibleSectionValue: (isVisibleSectionValue: boolean) => void;
}
export const SectionSettingsWrapper = ({
    sectionTitle,
    visibleSectionValue,
    isVisibleSectionValue,
    popoverContent,
    popoverLabel,
    necessaryFildInfo,
    disabled,
    handleToggleClick,
    setIsVisibleSectionValue,
    collapseComponent,
    sectionIcon,
}: SectionSettingsProps) => {
    return (
        <>
            <ListItemButton
                onClick={() => handleToggleClick(visibleSectionValue)}
                disabled={disabled}
                sx={(isVisibleSectionValue
                    ? {
                        height: "63px",
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        border: `1px solid ${theme.colors.gray05_input}`,
                        color: theme.colors.blue01_active,
                        borderTopLeftRadius: `8px`,
                        borderTopRightRadius: `8px`,
                        bgcolor: `${theme.colors.gray05_input}`,
                        ':hover': {
                            bgcolor: `${theme.colors.gray05_input}`,
                        },
                    }
                    : {
                        height: "63px",
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        border: `1px solid ${theme.colors.gray05_input}`,
                        color: theme.colors.black_primaryText,
                        borderRadius: '8px',
                        marginBottom: '8px',
                        bgcolor: `${theme.colors.gray04_background}`,
                        ':hover': {
                            bgcolor: `${theme.colors.gray05_input}`,
                            color: theme.colors.blue01_active,
                            'svg': {
                                color: theme.colors.blue01_active,
                            }
                        },
                    }
                )}
            >
                <ColumnWrapper>
                    <ListItemIcon
                        sx={{
                            'svg': {
                                alignSelf: 'center',
                                color: `${isVisibleSectionValue
                                    ? theme.colors.blue01_active
                                    : theme.colors.gray01_secondaryText
                                    }`
                            }
                        }}>
                        {sectionIcon}
                        {/* <LockIcon sx={{
                            alignSelf: 'center',
                            color: `${isVisibleSectionValue
                                ? theme.colors.blue01_active
                                : theme.colors.gray01_secondaryText
                                }`
                        }}  
                        />*/}
                    </ListItemIcon>
                    <ListItemText
                        primary={sectionTitle}
                        sx={{ alignSelf: 'center' }}
                    />
                    {necessaryFildInfo
                        ?
                        <FormFieldInfo
                            noPadding={false}
                            popoverLabel={popoverLabel ? popoverLabel : ""}
                            popoverContent={popoverContent ? popoverContent : ""}
                        />
                        :
                        null
                    }
                </ColumnWrapper>
                {/* {isVisibleSectionValue ? <ExpandLess /> : <ExpandMore />} */}
                <ExpandMoreIcon
                    sx={{
                        transition: `all 0.75s 0.25s`,
                        rotate: `${(isVisibleSectionValue)
                            ? "180deg"
                            : "0deg"}`,
                        color: `${(isVisibleSectionValue)
                            ? theme.colors.blue01_active
                            : theme.colors.gray01_secondaryText}`,
                        '&:hover': {
                            color: `${theme.colors.black_primaryText}`
                        },

                    }} />
            </ListItemButton>
            <Collapse in={isVisibleSectionValue} timeout="auto" unmountOnExit>
                <CollapseWrapper>
                    <Divider />
                    {collapseComponent}
                </CollapseWrapper>
            </Collapse>


        </>


    );
};

const ColumnWrapper = styled.div`
display:flex;
flex-direction:row;
`;
const CollapseWrapper = styled.div`
background-color: ${theme.colors.gray05_input};
padding: 0px 20px 20px 20px;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
margin-bottom: 20px;
border: 1px solid ${theme.colors.gray05_input};
border-top:none;
display: flex;
flex-direction: column;
`;